// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-featured-clips-unauth-subscription-modal .modal__container {
    width: 440px;
    padding: 0;
    margin: 0;
}

.home-featured-clips-unauth-subscription-modal .modal__container__close {
    width: 16px;
    height: 16px;
    top: 10px;
    right: 24px;
}

.home-featured-clips-unauth-subscription-modal__container {
    padding: 40px 24px 24px 24px;
    text-align: center;
}

.home-featured-clips-unauth-subscription-modal__container .hubicon-video_library::before {
    font-size: 54px;
    color: #0D6EFD;
}

.home-featured-clips-unauth-subscription-modal__container .baloa-headline-2 {
    font-size: 26px;
    margin-top: 24px;
    color: var(--primary-very-dark-color);
    font-weight: var(--font-bold);
}

.home-featured-clips-unauth-subscription-modal__container .baloa-names {
    margin-top: 24px;
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.home-featured-clips-unauth-subscription-modal__buttons {
    margin-top: 24px;
    display: flex;
    align-items: center;
}


.home-featured-clips-unauth-subscription-modal__buttons .primary-button.button {
    width: 100%;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    
    .home-featured-clips-unauth-subscription-modal .modal__container {
        width: 100%;
        margin: 18px;
    }

    .home-featured-clips-unauth-subscription-modal__container {
        padding: 40px 24px 16px 24px;
        text-align: center;
    }

    .home-featured-clips-unauth-subscription-modal__container .hubicon-video_library {
        font-size: 44px;
    }

    .home-featured-clips-unauth-subscription-modal__container .baloa-headline-2 {
        font-size: 18px;
        margin-top: 16px;
    }

    .home-featured-clips-unauth-subscription-modal__container .baloa-names {
        margin-top: 12px;
        font-size: 15px;
    }

    .home-featured-clips-unauth-subscription-modal__buttons .button {
        font-size: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/home/components/home-fatured-clips-unauth-play-modal/HomeFeaturedClipsUnauthPlayModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,WAAW;AACf;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".home-featured-clips-unauth-subscription-modal .modal__container {\n    width: 440px;\n    padding: 0;\n    margin: 0;\n}\n\n.home-featured-clips-unauth-subscription-modal .modal__container__close {\n    width: 16px;\n    height: 16px;\n    top: 10px;\n    right: 24px;\n}\n\n.home-featured-clips-unauth-subscription-modal__container {\n    padding: 40px 24px 24px 24px;\n    text-align: center;\n}\n\n.home-featured-clips-unauth-subscription-modal__container .hubicon-video_library::before {\n    font-size: 54px;\n    color: #0D6EFD;\n}\n\n.home-featured-clips-unauth-subscription-modal__container .baloa-headline-2 {\n    font-size: 26px;\n    margin-top: 24px;\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-bold);\n}\n\n.home-featured-clips-unauth-subscription-modal__container .baloa-names {\n    margin-top: 24px;\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.home-featured-clips-unauth-subscription-modal__buttons {\n    margin-top: 24px;\n    display: flex;\n    align-items: center;\n}\n\n\n.home-featured-clips-unauth-subscription-modal__buttons .primary-button.button {\n    width: 100%;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    \n    .home-featured-clips-unauth-subscription-modal .modal__container {\n        width: 100%;\n        margin: 18px;\n    }\n\n    .home-featured-clips-unauth-subscription-modal__container {\n        padding: 40px 24px 16px 24px;\n        text-align: center;\n    }\n\n    .home-featured-clips-unauth-subscription-modal__container .hubicon-video_library {\n        font-size: 44px;\n    }\n\n    .home-featured-clips-unauth-subscription-modal__container .baloa-headline-2 {\n        font-size: 18px;\n        margin-top: 16px;\n    }\n\n    .home-featured-clips-unauth-subscription-modal__container .baloa-names {\n        margin-top: 12px;\n        font-size: 15px;\n    }\n\n    .home-featured-clips-unauth-subscription-modal__buttons .button {\n        font-size: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
